'use client';

import { signOut } from 'next-auth/react';
import { tenantStore } from './tenantStore';

export async function handleSignOut(callbackUrl: string = '/assetcast/auth/signin'): Promise<void> {
  tenantStore.clearTenant();
  await signOut({ callbackUrl, redirect: false });
  window.location.href = callbackUrl;
}
